export const DEFAULT_TEXT = 'text-h4 text-gray-44';

export const GRAY_KEY_TITLE = 'text-gray-99 text-[11px] font-bold';
export const BLACK_VALUE_TITLE = 'text-[12px] font-bold text-gray-44';
